"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestfitQuestionModificationRequestEvent = void 0;
const enums_1 = require("../enums");
class BestfitQuestionModificationRequestEvent {
    constructor(questionType) {
        this.eventType = BestfitQuestionModificationRequestEvent.EventType;
        this.questionType = questionType;
        this.timestamp = new Date();
    }
}
exports.BestfitQuestionModificationRequestEvent = BestfitQuestionModificationRequestEvent;
BestfitQuestionModificationRequestEvent.EventType = enums_1.EventType.BESTFIT_MODIFY_ANSWER;
